export const templatesList = [
  "azurill", 
  "mastersunion",
  "Create Custom",
  "LFBA_LFMS",
  "LFTS 1(GEN)",
  "LFTS 2(SPL)",
  "bronzor",
  "chikorita",
  "ditto",
  "gengar",
  "glalie",
  "kakuna",
  "leafish",
  "nosepass",
  "onyx",
  "pikachu",
  "rhyhorn",
] as const;


export type Template = (typeof templatesList)[number];
